import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { isNil } from 'lodash';
import { ENUM_THEMES, THEMES } from '../../../shared/helpers/app.constants';
import { UserService } from '../../../shared/services';
import { ThemesSettingsService } from '../../../shared/services/themes-settings.service';
import { UnitSystemService } from '../../../shared/services/unit-system.service';

@Component({
  selector: 'app-units-settings',
  templateUrl: './units-settings.component.html'
})
export class UnitsSettingsComponent implements OnInit {
  selectOptions = [];
  form: FormGroup;

  constructor(
    private userService: UserService,
    private unitsSystemService: UnitSystemService
  ) { }

  get units() {
    return this.form.controls.units;
  }

  ngOnInit(): void {
    this.selectOptions = this.unitsSystemService.getDefaultOptions();
    const localData = this.unitsSystemService.loadUnitSettings();
    const selectOption = this.selectOptions.find(x => x.id === localData);
    const activeOption = selectOption || this.selectOptions[0];
    this.form = new FormGroup({
      units: new FormControl(activeOption)
    });
  }

  onChangeOption(eventData) {
    if (!eventData || isNil(eventData.id)) return;
    this.userService.updateCurrentUser({unitSystem: eventData.id}).subscribe(() => {
      this.unitsSystemService.setUnitSettings(eventData.id);
    }, err => {
      //
    });
  }
}
